import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import defaultTheme from "../../theme/default";
import { ToastNotifications } from "../../context/toast-notifications";
import Toasts from "../toast-notification";
import { addToast, removeToast } from "../../redux/actions";
import PricePrescriptionsDetails from "./price-prescription-details";
import PricePrescriptionsSearch from "./price-prescription-search";

const PRICE_PRESCRIPTIONS_TOAST_ID = "PRICE_PRESCRIPTIONS_TOAST_ID";

const PricePrescriptions = ({
  toasts,
  addToast,
  removeToast,
  theme,
  extendedConfiguration: {
    pricePrescriptions: {
      zipCode,
      prescriptionName,
      addToFavorite,
      favoriteList,
      profileId
    }
  }
}) => {
  const components = { ...defaultTheme, ...theme };
  const { Loader } = components;

  const [drugPrice, setDrugPrice] = useState();
  const [discountCard, setDiscountCard] = useState();
  const [showDetails, setShowDetails] = useState(false);
  const [loadingPage, setLoadingPage] = useState(false);

  const handleSelect = ([drugPrice, discountCard]) => {
    setDrugPrice(drugPrice);
    setDiscountCard(discountCard);
    setShowDetails(true);
    setLoadingPage(false);
  };

  const handleValidation = ({ isValid, message }) => {
    if (isValid) {
      removeToast(PRICE_PRESCRIPTIONS_TOAST_ID);
    } else {
      addToast({
        id: PRICE_PRESCRIPTIONS_TOAST_ID,
        message
      });
    }
  };

  return (
    <ToastNotifications components={components}>
      <Toasts
        toasts={toasts}
        onClose={toastId => removeToast(toastId)}
        components={components}
      />
      <form
        id='containerForm'
        style={{ display: showDetails || loadingPage ? "none" : "block" }}
      >
        <PricePrescriptionsSearch
          onSelectStart={() => setLoadingPage(true)}
          onSelect={handleSelect}
          onValidation={handleValidation}
          components={components}
          prescription={prescriptionName}
          zipCode={zipCode}
          addToFavorite={addToFavorite}
          favoriteList={favoriteList}
        />
      </form>
      {showDetails && (
        <PricePrescriptionsDetails
          drugPrice={drugPrice}
          discountCard={discountCard}
          onBack={() => setShowDetails(false)}
          components={components}
          addToFavorite={addToFavorite}
          favoriteList={favoriteList}
          profileId={profileId}
        />
      )}
      {loadingPage && <Loader />}
    </ToastNotifications>
  );
};

PricePrescriptions.propTypes = {
  addToast: PropTypes.func.isRequired,
  removeToast: PropTypes.func.isRequired,
  fieldConfigurations: PropTypes.object,
  toasts: PropTypes.array,
  theme: PropTypes.object
};

export default connect(
  ({ tdFlow }) => ({
    toasts: tdFlow.toasts,
    screenParams: tdFlow.screenParams
  }),
  { addToast, removeToast }
)(PricePrescriptions);
